import React from 'react';
import homeAbout from '../assets/homeAbout.png';

const HomeAbout = () => {
  return (
    <div className='px-4 sm:px-8 md:px-16 lg:px-24 py-8'>
      <div className='max-w-screen-xl mx-auto flex flex-col gap-8'>
        <p className='text-2xl sm:text-3xl font-semibold leading-snug text-center'>
          About eSparse Matrix Solutions Private Limited
        </p>

        <p className='text-base sm:text-lg font-semibold text-justify'>
          eSparse Matrix Solutions Private Limited is a software agency in Pune that includes
          Enterprise Software development, Website designing and Software development services,
          Mobile application development, AI/ML Development.
        </p>

        <div className='flex flex-col lg:flex-row gap-8 items-center lg:items-start'>
          {/* Text Content */}
          <div className='w-full lg:w-1/2 flex flex-col gap-6'>
            <p className='text-base leading-relaxed text-justify'>
              At eSparse Matrix Solutions, we prioritize excellence, relevance, accessibility, and
              usability. Our expert developers and digital marketers craft tailored business
              software solutions. We leverage cutting-edge technologies to deliver the best in
              software development and <strong>AI/ ML Development...</strong>
            </p>

            <p className='text-base leading-relaxed text-justify'>
              What sets us apart is our focus on software that clearly communicates business
              objectives and ensures user-oriented functionality. Our goal is to articulate your
              business case effectively, providing top-notch software development services in Pune...
            </p>

            <button className='bg-[#006BD3] w-fit px-6 py-2 rounded text-white text-sm'>
              Explore more
            </button>
          </div>

          {/* Image */}
          <div className='w-full lg:w-1/2'>
            <img src={homeAbout} alt='About eSparse Matrix Solutions' className='w-full rounded' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
